@if (!isLoading) {
  <footer [class]="cssClasses()">
    <ng-content></ng-content>
    <div class="navbar-text">
      <div [innerHtml]="companyFooterLabel | escapeHtml: { year }" data-automation="footer-year"></div>
      @if (showSupportLink) {
        <a id="login-support-link" [routerLink]="'/support'" target="_blank" data-automation="login-support-link">
          {{ 'tkey;footer.support' | translate }}
        </a>
      }
    </div>
  </footer>
}
